const AdmissionStepEnum = {
  Canceled: 0,

  Request: 10,
  Admission: 20,
  Repair: 30,
  ReadyForDelivery: 40,
  Delivered: 1000,
  // WaitingForBike: 11,
  // DeliveryToBike: 12,
  // DeliveryToAgent: 13,
  // DeliveryToCompany: 14,
  // PostToAgent: 15,
  // PostToCompany: 16,

  // Admission: 100,
  AssignToInputQualityControl: 101,
  InputQualityControl: 102,
  AssignToRepair: 103,
  // Repair: 104,
  AssignToOutputQualityControl: 105,
  OutputQualityControl: 106,
  AssignToReplacement: 107,
  Replacement: 108,
  FinancialApprovalCustomer: 109,
  FinancialApprovalAgent: 110,
  FinancialApprovalCompany: 111,
  Complete: 112,

  AssignToReceiveInPerson: 200,
  ReceiveInPerson: 201,

  AssignToPostToBike: 300,
  ReadyToPostToBike: 301,
  ReadyToPostToAgent: 302,
  ReadyToPostToCustomer: 303,

  // Archive: 1000,
};


module.exports = {
  AdmissionStepEnum,
};

